import React, { Fragment, useEffect } from 'react';
import FB from './FB';
import GGL from './GGL'
import AcKIT from './AcKIT';
import fetch from '../fetch/fetch';
import { saveSession } from '../common/common';

const useScript = (s) => {
    useEffect(() => {
        const script = document.createElement('script');
        script.type = 'text/javascript'
        script.async = true;
        script.innerHTML = s
        document.body.appendChild(script);
        return () => {
            document.body.removeChild(script);
        }
    }, [s])
};

const useSrcScript = (src) => {
    useEffect(() => {
        const script = document.createElement('script');
        script.type = 'text/javascript'
        script.async = true;
        script.defer = true;
        script.src = src
        document.body.appendChild(script);
        return () => {
            document.body.removeChild(script);
        }
    }, [src])
};

const getBraintreeToken = (url) => fetch.get(url)
    .then(({ data }) => saveSession('client_token', data.client_token))

const useGetConfig = (url, fn) => {
    useEffect(() => {
        fn(url)
    }, [url])
};

const ScriptProvider = ({ children }) => {

    useScript(FB);
    useSrcScript(GGL.src);
    useScript(GGL.script);
    useSrcScript(AcKIT.src);
    useScript(AcKIT.script);
    useGetConfig('/tracker-purchase/get-client-token', getBraintreeToken)


    return (
        <Fragment>
            {
                children
            }
        </Fragment>
    )
}

export default ScriptProvider;
